import { useQuery } from '@tanstack/react-query';
import { fetchAuthSession } from 'aws-amplify/auth';

export interface UserInfo {
  email: string;
  familyName: string;
  givenName: string;
}

const EMPTY_USER_INFO: UserInfo = { email: '', familyName: '', givenName: '' };

const getUserInfo = async (): Promise<UserInfo> => {
  const { tokens } = await fetchAuthSession();
  const payload = tokens?.idToken?.payload;

  return {
    email: typeof payload?.email === 'string' ? payload.email : '',
    familyName: typeof payload?.family_name === 'string' ? payload.family_name : '',
    givenName: typeof payload?.given_name === 'string' ? payload.given_name : '',
  };
};

interface UseUserInfoResponse {
  isLoading: boolean;
  userInfo: UserInfo;
}

export const useUserInfo = (): UseUserInfoResponse => {
  const { data: userInfo = EMPTY_USER_INFO, isLoading } = useQuery({
    queryFn: getUserInfo,
    queryKey: ['userInfo'],
  });

  return { isLoading, userInfo };
};
